import { createAction, props } from '@ngrx/store';

export const showError = createAction('[Client.Error] Show Error', props<{ payload: string }>());
